/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { OidcSecure, useOidc } from "@axa-fr/react-oidc";
import { ConfigurationVariables } from "../config";

const LoggedIn = () => {
  const { logout } = useOidc();
  return (
    <>
      {
      }
    </>
  );
};

export default LoggedIn;
